import api from '@/api/axios';

const state = {
  projects: [],
  isLoading: false,
  error: null,
  userProjects: [],
  projectCrawlings: [],
};

const mutations = {
  SET_PROJECTS(state, projects) {
    state.projects = projects;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_PROJECT_PARTICIPANTS(state, participants) {
    state.projectParticipants = participants;
  },
  ADD_PROJECT(state, project) {
    state.projects.push(project);
  },
  SET_USER_PROJECTS(state, projects) {
    state.userProjects = projects;
  },
  SET_PROJECT_CRAWLINGS(state, crawlings) {
    state.projectCrawlings = crawlings;
  },
};

const actions = {
  async fetchGIGProjects({ commit, rootState }) {
    
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get(`/api/v1/project/gig_projects`);
      console.log('response', response.data)
      commit('SET_PROJECTS', response.data);
    } catch (error) {
      console.error('Failed to fetch projects:', error);
      if (error.response && error.response.status === 401) {
        // Token is invalid or expired
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || 'Failed to fetch projects');
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async fetchProjectParticipants({ commit, rootState }, projectId) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get(`/api/v1/project/gig_project_participants/${projectId}`);
      commit('SET_PROJECT_PARTICIPANTS', response.data);
    } catch (error) {
      console.error('Failed to fetch project participants:', error);
      commit('SET_ERROR', error.message || 'Failed to fetch project participants');
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async createProject({ commit, rootState }, projectData) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.post(`/api/v1/project/new_project`, projectData);
      commit('ADD_PROJECT', response.data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to create project:', error);
      if (error.response) {
        console.error('Error response:', error.response.data);
        commit('SET_ERROR', `Failed to create project: ${JSON.stringify(error.response.data)}`);
      } else {
        commit('SET_ERROR', error.message || 'Failed to create project');
      }
      return { success: false, error: error.response ? error.response.data : (error.message || 'Failed to create project') };
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async fetchUserProjects({ commit, rootState }) {
    commit('SET_LOADING', true);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get('/api/v1/project/user_projects');
      commit('SET_USER_PROJECTS', response.data);
      
    } catch (error) {
      console.error('Failed to fetch user projects:', error);
      commit('SET_ERROR', error.message || 'Failed to fetch user projects');
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async fetchProjectCrawlings({ commit, rootState }) {
    try {
      // Get token from rootState
      const token = rootState.auth.token;
      const user = rootState.auth.user;
      
      if (!token || !user) {
        throw new Error('No authentication token or user found');
      }

      const response = await api.get(`/api/v1/project/project_crawling_jobs/${user.pid}`)
      
      commit('SET_PROJECT_CRAWLINGS', response.data)
      return response.data
    } catch (error) {
      console.error('Error fetching project crawlings:', error)
      commit('SET_PROJECT_CRAWLINGS', []) // Set empty array on error
      throw error
    }
  },
  async fetchParticipantsByIds({ commit, rootState }, participantIds) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }


      const response = await api.post(`/api/v1/project/participants_by_ids`,
        { participant_ids: participantIds },
      );
      return response.data;
    } catch (error) {
      console.error('Failed to fetch participants:', error);
      commit('SET_ERROR', error.message || 'Failed to fetch participants');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async updateSimpleMentionPrompt({ commit, rootState }, { project_id, simple_mention_prompt, simple_mention_example }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await api.post(`/api/v1/project/update_simple_mention_prompt`, {
        project_id,
        simple_mention_prompt,
        simple_mention_example
      });

      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to update simple mention prompt:', error);
      commit('SET_ERROR', error.message || 'Failed to update simple mention prompt');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async fetchProjectInfo({ commit, rootState }, project_id) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await api.get(`/api/v1/project/project_info/${project_id}`);

      return response.data;
    } catch (error) {
      console.error('Failed to fetch project info:', error);
      commit('SET_ERROR', error.message || 'Failed to fetch project info');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

const getters = {
  allProjects: state => state.projects,
  isLoading: state => state.isLoading,
  error: state => state.error,
  userProjects: state => state.userProjects,
  projectCrawlings: state => state.projectCrawlings,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
